import cx from "classnames";

export interface ToolCallIndicatorNodeLabelProps {
  children: React.ReactNode;
  className?: string;
}

export default function ToolCallIndicatorNodeLabel({
  children,
  className,
}: ToolCallIndicatorNodeLabelProps) {
  return (
    <div
      className={cx(
        "uppercase tracking-wide text-[9px] text-text-secondary font-medium leading-4",
        className
      )}
    >
      {children}
    </div>
  );
}
